<template>
  <div class='course-details'>
    <!-- 页面下拉刷新 -->
    <common-back-header :backPath="backPath" :tabIndex="tabIndex" :screenIcon="true" :screenType="isLandscape" @handle-change-screen="onChangeScreen"/>
    <div class="details-contain">
      <!-- 内部tabs -->
      <common-tabs v-show="bannerList.length" :list="bannerList" :tabNum="tabNum" :canSwipeNum="4" ref="typeTabs" @change-tab="changeTab" >
        <cp-page-refresh @refresh="refresh" ref="pageRefresh">
          <!-- 内部tab内容 -->
          <div :class="isLandscape?'item-list-vertical-screen':'item-list-landscape'">
            <!-- <div class="artical-contain">
              <h3 class="title" v-text="summary.title"></h3>
              <div class="artical">
                <p :class="getMoreFlag?'':'two-line'" v-text="summary.remark"></p>
                <div class="more-contain" v-if="summary.remark">
                  <div class="more">
                    <p v-if="getMoreFlag" @click="getMore">收起更多</p>
                    <p v-else @click="getMore">查看更多</p>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="list-contain">
              <div class="item" v-for="(item,index) in itemList" :key="index">
                <div
                  id='avatar'
                  :style="{
                    'background-color': item.bgColor ? item.bgColor : 'white',
                    'background-image': item.bgImage
                      ? 'url(' + item.bgImage+ '?x-oss-process=image/resize,p_50' + ')'
                      : 'none',
                      'background-size': '100% 100%'
                  }"
                  class="slide-scale animate__animated">
                  <ppt-tool
                    :data="item"
                    :scale="scale"
                    @mPlay="mPlay"
                    ref="allTool">
                  </ppt-tool>
                </div>
                <div v-if="!isLandscape" class="icon">
                  <img src="@/assets/images/common/icon_allScreen.png" alt="" @click="handleImg(item)">
                </div>
                <div class="number" v-text="index+1"></div>
              </div>
            </div>
          </div>
        </cp-page-refresh>
      </common-tabs>
    </div>
    <!-- 模型视频播放 -->
    <player
      v-model="showPlay"
      :playDatas="playData"
      :id="id"
      :playType="playType"
      :modelName="modelName"
      :chapterId="activeIndexDar"
      @change="onPlayerChange"
    ></player>
    <van-image-preview
      v-if="largeImgList.length"
      :showIndex="false"
      :showIndicators="false"
      v-model="showLargeImg"
      :images="largeImgList">
    </van-image-preview>
  </div>
</template>

<script>
import { course, aliyun } from '@/agent'
import CommonBackHeader from '@/views/layout/common-back-header'
import CommonTabs from '@/views/components/common-tabs-2'
import PptTool from './ppt-tool'
import Player from './player' // 预览
export default {
  name: 'ModelCourse',
  components: {
    'common-back-header': CommonBackHeader,
    'common-tabs': CommonTabs,
    'ppt-tool': PptTool,
    'player': Player
  },
  props: {
  },
  data () {
    return {
      showLargeImg: false,
      index: 0,
      largeImgList: [],
      bannerList: [], // 顶部tab页签的列表
      currentTab: '', // 当前tab页签
      summary: { // 顶部文字详情
        title: '',
        remark: ''
      },
      itemList: [], // 详情列表
      id: '', // 课程ID
      backPath: 'home', // 返回路径
      tabIndex: '', // 上一页的tab页签
      getMoreFlag: false, // 查看更多
      scale: 0.0654, // 详情二级界面的图标显示比例  0.25 px   0.0654 vw
      playData: '', // 二级界面的数据
      showPlay: false, // 是否显示二级界面模型视频音频的出发图
      playType: '', // 二级界面的播放类型
      modelName: '', // 二级界面的模型名称
      activeIndexDar: '',
      tabNum: 0,
      isLandscape: false, // 是不是横屏
    }
  },
  mounted () {
    this.init()
  },
  watch: {
  },
  methods: {
    onChangeScreen () {
      this.isLandscape = !this.isLandscape
      if (this.isLandscape) {
        this.scale = 0.109
      } else {
        this.scale = 0.0654
      }
    },
    handleImg (item) {
      if (item.bgImage) {
        this.largeImgList = []
        this.largeImgList[0] = item.bgImage
        this.showLargeImg = true
      }
    },
    onChange (index) {
      this.index = index
    },
    init () {
      this.tabIndex = this.$route.query.tabIndex
      this.backPath = this.$route.query.backPath
      this.id = this.$route.query.id
      if (this.$route.query.flag) { // 首页顶部轮播-点击进来的-根据 章节ID
        this.getCourseDetailByChapterId(this.id)
        this.getCourseDetails(this.id)
      } else { // 课程列表页进来的-根据 课程id
        this.getChapterIdByCourseId(this.id)
      }
    },
    // 下拉刷新页面
    refresh () {
      // Object.assign(this.$data, this.$options.data()) // 重置data的数据为初始状态
      // this.init()
      this.itemList = [] // 详情列表
      this.getCourseDetails(this.currentTab)
      this.$refs.pageRefresh.hideFresh() // 隐藏下拉刷新
    },
    /**
     * 视频、模型、音频播放
     */
    mPlay (val) {
      let item = val.val
      let description = ''
      let descriptionArr = []
      if (item.description) {
        description = item.description
        if (description.indexOf('\n') != -1) {
          descriptionArr = description.split('\n')
          for (let i = 0; i < descriptionArr.length; i++) {
            descriptionArr[i] = '<p>' + descriptionArr[i] + '</p>'
          }
          if (descriptionArr.length) {
            description = descriptionArr.join('')
          }
        } else {
          if (description.indexOf('<p>') == -1) {
            description = '<p>' + description + '</p>'
          }
        }
      } else {
        description = '<p>未知</p>'
      }
      item.description = description
      this.showPlay = val.ste
      this.playData = item
      // this.playData = val.val
      this.id = val.id
      this.playType = val.type
      this.modelName = val.modelName
    },
    onPlayerChange (val) {
      // console.log(val)
    },
    // 获得顶部tab列表
    getChapterIdByCourseId (id) {
      this.$loading.show()
      course.getChapterIdByCourseId(id).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.bannerList = res.data.map(item => {
            item.dictLabel = item.name
            return item
          })
          this.currentTab = this.bannerList[0].id
          this.activeIndexDar = Number(this.currentTab)
          this.getCourseDetailByChapterId(this.currentTab)
          this.getCourseDetails(this.currentTab)
        }
      })
    },
    // 获得课程详情信息
    getCourseDetailByChapterId (id) {
      this.$loading.show()
      course.getCourseDetailByChapterId(id).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.summary.title = res.data.name ? res.data.name : ''
          this.summary.remark = res.data.remark ? res.data.remark : ''
        }
      })
    },
    // 获得课程列表
    getCourseDetails (id) {
      this.$loading.show()
      course.getCourseDetails(id).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.itemList = res.data.map(item => {
            item.detailPageList = item.detailPageImageVOs
              .concat(item.detailPageModelVOs)
              .concat(item.detailPageVideoVOs)
            item.bgImage = this.formatAliyunPath(item.bgImage)
            return item
          })
          for (let i = 0; i < this.itemList.length; i++) {
            if (this.itemList[i].uiImageVOs && this.itemList[i].uiImageVOs.length) {
              this.itemList[i].uiImageVOs = this.itemList[i].uiImageVOs.filter(item => {
                item.isDeleted = JSON.parse(item.isDeleted)
                return !item.isDeleted
              })
            }
            if (this.itemList[i].uiModelVOs && this.itemList[i].uiModelVOs.length) {
              this.itemList[i].uiModelVOs = this.itemList[i].uiModelVOs.filter(item => {
                item.isDeleted = JSON.parse(item.isDeleted)
                return !item.isDeleted
              })
            }
            if (this.itemList[i].uiTextVOs && this.itemList[i].uiTextVOs.length) {
              this.itemList[i].uiTextVOs = this.itemList[i].uiTextVOs.filter(item => {
                item.isDeleted = JSON.parse(item.isDeleted)
                return !item.isDeleted
              })
            }
            if (this.itemList[i].shapeList && this.itemList[i].shapeList.length) {
              this.itemList[i].shapeList = this.itemList[i].shapeList.filter(item => {
                item.isDeleted = JSON.parse(item.isDeleted)
                return !item.isDeleted
              })
            }
            if (this.itemList[i].uiVideoVOs && this.itemList[i].uiVideoVOs.length) {
              this.itemList[i].uiVideoVOs = this.itemList[i].uiVideoVOs.filter(item => {
                item.isDeleted = JSON.parse(item.isDeleted)
                return !item.isDeleted
              })
            }
            if (this.itemList[i].uiAudioVOs && this.itemList[i].uiAudioVOs.length) {
              this.itemList[i].uiAudioVOs = this.itemList[i].uiAudioVOs.filter(item => {
                item.isDeleted = JSON.parse(item.isDeleted)
                return !item.isDeleted
              })
            }
            if (this.itemList[i].tableList && this.itemList[i].tableList.length) {
              this.itemList[i].tableList = this.itemList[i].tableList.filter(item => {
                item.isDeleted = JSON.parse(item.isDeleted)
                return !item.isDeleted
              })
            }
            if (this.itemList[i].chartList && this.itemList[i].chartList.length) {
              this.itemList[i].chartList = this.itemList[i].chartList.filter(item => {
                item.isDeleted = JSON.parse(item.isDeleted)
                return !item.isDeleted
              })
            }
            if (this.itemList[i].detailPageList && this.itemList[i].detailPageList.length) {
              this.itemList[i].detailPageList = this.itemList[i].detailPageList.filter(item => {
                item.isDeleted = JSON.parse(item.isDeleted)
                return !item.isDeleted
              })
            }
          }
        }
      })
    },
    // 切换tab页签
    changeTab (index, item) {
      this.tabNum = index
      this.currentTab = item.id
      this.activeIndexDar = Number(this.currentTab)
      this.itemList = []
      this.getCourseDetails(this.currentTab)
    },
    // 详情介绍，查看更多，内容展示和折叠
    getMore () {
      this.getMoreFlag = !this.getMoreFlag
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    }
  }
}
</script>
<style lang='scss' scoped>
.course-details{
  height: 100%;
  background: #fff;
  .details-contain{
    padding-top: 44px;
    box-sizing: border-box;
    .common-tabs{
      background: #fff;
      height: 100%;
      overflow: scroll;
      background: #111111;
      padding-bottom:44px;
    }
    .item-list-landscape{//竖屏
      padding: 20px;
      .artical-contain{
        margin-bottom: 25px;
        .title{
          opacity: 1;
          font-size: 24px;
          font-family: YouSheBiaoTiHei, YouSheBiaoTiHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #ffffff;
          margin-bottom: 11px;
        }
        .artical{
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Normal;
          font-weight: Normal;
          text-align: left;
          color: #828282;
          line-height: 18px;
          position: relative;
          p{
            letter-spacing:0;
            text-align: justify;
            overflow: hidden;
          }
          .two-line{
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .more-contain{
            width: 100%;
            text-align: right;
            background: #111111;
            .more{
              color:#E50914;
              display: flex;
              justify-content: flex-end;
            }
          }
        }
      }
      .list-contain{
        .item{
          width: 100%;
          border-radius: 3px;
          overflow: hidden;
          margin-bottom: 10px;
          position: relative;
          img{
            width: 100%;
            display: block;
            height: auto;
          }
          .number{
            position: absolute;
            width: 35px;
            height: 20px;
            opacity: 0.5;
            background: #000000;
            border-radius:  3px 0px 3px 0px;
            top:0;
            left: 0;
            text-align: center;
            line-height: 20px;
            color:#E50914;
          }
          .icon{
            position: absolute;
            width: 21px;
            height: 21px;
            bottom:7px;
            right: 6px;
            img{
              width: 100%;
            }
          }
        }
        #avatar{
          width:100%;
          height: 188px;
        }
      }
    }
    .item-list-vertical-screen{//横屏
      padding: 30px;
      .artical-contain{
        margin-bottom: 25px;
        .title{
          opacity: 1;
          font-size: 24px;
          font-family: YouSheBiaoTiHei, YouSheBiaoTiHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #ffffff;
          margin-bottom: 11px;
        }
        .artical{
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Normal;
          font-weight: Normal;
          text-align: left;
          color: #828282;
          line-height: 18px;
          position: relative;
          p{
            letter-spacing:0;
            text-align: justify;
            overflow: hidden;
          }
          .two-line{
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .more-contain{
            width: 100%;
            text-align: right;
            background: #111111;
            .more{
              color:#E50914;
              display: flex;
              justify-content: flex-end;
            }
          }
        }
      }
      .list-contain{
        box-sizing: border-box;
        width: 100%;
        .item{
          position: relative;
          width: 315px;
          height: 560px;
          border-radius: 3px;
          overflow: hidden;
          margin-bottom: 10px;
          .number{
            position: absolute;
            width: 35px;
            height: 20px;
            right: 0;
            top: 0;
            transform: rotate(90deg) translate(7px,-8px);
            opacity: 0.5;
            background: #000000;
            border-radius: 3px 0px 3px 0px;
            text-align: center;
            line-height: 20px;
            color:#E50914;
          }
        }
        #avatar{
          position: absolute;
          content: "";
          display: block;
          height: 315px;
          width: 560px;
          transform: rotate(90deg) translate(21.8%,39%);
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.course-details{
  .van-sticky {
      background: #fff;
  }
  .shade-box{
    background: #fff;
  }
}
</style>
